import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class BankParticularsService {

  constructor( private httpService: HttpService) { }

    sampleTcsRecord(object) {
        var request = {
            URL: "bankparticulars/tcsRegisterRecordentry",
            DATA: object
        }
        return this.httpService.post(request);
    }

    lockerdetailsform(lockerdetail) {
        var request = {
            URL: "bankparticulars/lockerRegisterRecordentry",
            DATA: lockerdetail
        }
        return this.httpService.post(request);

    }

    depositdetailsform(depositdetails) {
        var request = {
            URL: "bankparticulars/depositRegisterRecordentry",
            DATA: depositdetails
        }
        return this.httpService.post(request);
    }

    loandetailsform(loandetail) {
        var request = {
            URL: "bankparticulars/loanRegisterRecordentry",
            DATA: loandetail
        }
        return this.httpService.post(request);

    }

    closureofbankaccountform(closuredetail) {
        var request = {
            URL: "bankparticulars/closureRegisterRecordentry",
            DATA: closuredetail
        }
        return this.httpService.post(request);

    }

    getRegisterDirector(object) {
        var registerList = {
            URL: "bankparticularsroute/getBankDetails/5cee33d225242e023acfb2d4",
            DATA: object
        }
        return this.httpService.post(registerList);
    }

    removedetails(_id) {
        var request = {
            URL: "bankparticulars/delete/" + _id
        }
        return this.httpService.get(request);
    }


    updatebank(_id) {
        var editlist = {
            URL: "bankparticulars/update/" + _id,
        }
        return this.httpService.get(editlist);
    }

    updateBankAccountParticulars(object, id) {
        var request = {
            URL: "bankparticulars/updateBankAccountParticular/" + id,
            DATA: object
        }
        return this.httpService.post(request);
    }
    generateBankAccountDocument(object) {
        var request = {
            URL: "bankparticulars/generateBankAccountDocument",
            DATA: object
        }
        return this.httpService.post(request);
    }

    downloadBankAccountFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "bankparticulars/downloadDocument/" + id + "/" + type + "/" + token;
    }
    downloadBankAccountPdfFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "bankparticulars/downloadPdfDocument/" + id + "/" + type + "/" + token;
    }

}

